export const iconFontAwesomeFoodBeverageCarrot = (
	<i className="fa-solid fa-carrot"></i>
);
